const initializeCustomerShowcase = (attempt = 0) => {
  const showcase = document.querySelector('.nospacescroll');

  if (!showcase) return;

  if (typeof window.Swiper !== 'function') {
    if (attempt < 20) setTimeout(() => initializeCustomerShowcase(attempt + 1), 250);
    return;
  }

  showcase.classList.remove('mySwiper');

  if (showcase.swiper) showcase.swiper.destroy(true, true);

  new window.Swiper(showcase, {
    slidesPerView: 1.18,
    spaceBetween: 12,
    loop: true,
    loopAdditionalSlides: 7,
    watchOverflow: false,
    observer: true,
    observeParents: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      600: { slidesPerView: 2, spaceBetween: 16 },
      900: { slidesPerView: 3, spaceBetween: 16 },
      1200: { slidesPerView: 5, spaceBetween: 16 },
    },
  });
};

let customerShowcaseTimer;
const scheduleCustomerShowcase = () => {
  clearTimeout(customerShowcaseTimer);
  customerShowcaseTimer = setTimeout(initializeCustomerShowcase, 750);
};

scheduleCustomerShowcase();
document.addEventListener('DOMContentLoaded', scheduleCustomerShowcase);
window.addEventListener('load', scheduleCustomerShowcase);
document.addEventListener('shopify:section:load', scheduleCustomerShowcase);
